import React from 'react';
import PropTypes from 'prop-types';
import { Box, Card, CardContent, Typography, Stack } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import TotalIcon from '@mui/icons-material/AllInbox';
import { LoadingWrapper } from '../loading';
import useResponsive from '../../hooks/useResponsive';

const InventoryAssignmentStatsCards = ({ stats, isLoading }) => {
  const mdUp = useResponsive('up', 'md');

  return (
    <LoadingWrapper
      isLoading={isLoading}
      loadingType="skeleton"
      skeletonCount={4}
      gridProps={{ xs: 12, sm: 6, md: 3 }}
      containerSx={{ marginY: 3 }}
    >
      <Box display={mdUp ? 'flex' : ''} gap={2} marginY={3}>
        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              Total Assignments
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <TotalIcon color="primary" />
              <Typography variant="h5">{stats.total_assignments || 0}</Typography>
            </Stack>
          </CardContent>
        </Card>
        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              Active Assignments
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <AssignmentIcon color="primary" />
              <Typography variant="h5">{stats.active_assignments || 0}</Typography>
            </Stack>
          </CardContent>
        </Card>
        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              Returned
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <CheckCircleIcon color="success" />
              <Typography variant="h5" color="success.main">{stats.returned_assignments || 0}</Typography>
            </Stack>
          </CardContent>
        </Card>
        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              Overdue
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <WarningIcon color="error" />
              <Typography variant="h5" color="error.main">{stats.overdue_assignments || 0}</Typography>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </LoadingWrapper>
  );
};

InventoryAssignmentStatsCards.propTypes = {
  stats: PropTypes.shape({
    total_assignments: PropTypes.number,
    active_assignments: PropTypes.number,
    returned_assignments: PropTypes.number,
    overdue_assignments: PropTypes.number,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default InventoryAssignmentStatsCards;